import React from "react"
import IconLink from "./IconLink"
import button from "./button.module.scss"
import Wave from "../images/waves/footer-wave.svg"
import footer from "./footer.module.scss"
import logo from "../images/logotype.svg"
import flag from "../images/da-flag.png"

export default function Footer() {
  return (
    <footer>
      <img src={Wave} alt="" style={{transform: "translateY(1px)", width:"100%"}} />
      <div className={footer.content}>
        <div className={footer.wrapper}>
          <div className={footer.toprow}>
            <img className={footer.logo} src={logo} alt="Logo" />
          </div>
          <div>
            <div className={footer.socials}>
              <IconLink
                href="https://facebook.com"
                icon="facebook"
                text="minutscript"
              />
              <IconLink
                href="https://linkedin.com"
                icon="linkedin"
                text="minutscript"
              />
              <IconLink
                href="https://twitter.com"
                icon="twitter"
                text="@minutscript"
              />
            </div>
          </div>
          <div className={footer.contact}>
            <h3>Got any questions?</h3>
            <p>
              If you got any questions about the app,
              <br />feel free to contact us on email.
            </p>
            <a href="mailto:hello@minutscript.com">hello@minutscript.com</a>
          </div>
          <div className={footer.form}>
            <h3>Subscribe to our newsletter</h3>
            <label htmlFor={"email"}>E-Mail</label>
            <input type="email" id={"email"} name="email" required></input>
            <button className={`${button.btn} ${button.outline}`}>
              Sign Up
            </button>
          </div>
          <div className={footer.botrow}>
            <div className={footer.support}>
              <p>Need help?</p>
              <a href="mailto:support@minutscript.com">
                support@minutscript.com
              </a>
            </div>
            <div>
              <p>Made In</p>
              <img src={flag} alt="Danish Flag" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
